import { ConfigModel } from '@ibe/services';

export const wait = (delay?: number): Promise<void> => {
  return new Promise(resolve => {
    setTimeout(resolve, delay || 100);
  });
};

export const customRoundNumber = (
  value: number,
  roundPricesToWholeNumber: ConfigModel['roundPricesToWholeNumber']
): number => {
  if (roundPricesToWholeNumber === 'ROUND_HALF_DOWN_MODE') {
    return -Math.round(-value);
  } else if (roundPricesToWholeNumber === 'ROUND_DOWN_MODE') {
    return value >= 0 ? Math.floor(value) : Math.ceil(value);
  } else if (roundPricesToWholeNumber === 'ROUND_UP_MODE') {
    return value >= 0 ? Math.ceil(value) : Math.floor(value);
  } else if (roundPricesToWholeNumber === 'DEFAULT_MODE') {
    return Math.round(value);
  } else {
    return value;
  }
};

export const roundToNearest = (
  value: number,
  roundTo: number,
  direction: 'UP' | 'DOWN'
): number => {
  const roundFn = direction === 'UP' ? Math.ceil : Math.floor;
  return roundFn(value / roundTo) * roundTo;
};

const isValueSet = (value: string | number | undefined | null): value is number | string => {
  return value !== undefined && value !== null;
};

export default isValueSet;
